var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ButtonType } from '@philips-internal/oswald-ui-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener, FocusEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isEnumValid } from '@philips-internal/oswald-ui-utils';
class ButtonAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
        /** @event */
        this.onFocus = new FocusEventListener();
        /** @event */
        this.onBlur = new FocusEventListener();
    }
    /**
     * Gets the button value.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Sets the button value.
     *
     * @param value - The button value.
     */
    setValue(value) {
        this.setState({ value });
    }
    /**
     * Gets the button icon.
     */
    getIcon() {
        return this.state.icon;
    }
    /**
     * Sets the button icon.
     *
     * @param icon - The button icon.
     */
    setIcon(icon) {
        this.setState({ icon });
    }
    /**
     * Gets the button type.
     */
    getType() {
        return this.state.type;
    }
    /**
     * Sets the button type.
     *
     * @param type - The button type.
     */
    setType(type) {
        if (!isEnumValid(ButtonType, type))
            return;
        this.setState({ type });
    }
    /**
     * Gets the button background.
     */
    getBackground() {
        return this.state.background;
    }
    /**
     * Sets the button background.
     *
     * @param background - The button background.
     */
    setBackground(background) {
        this.setState({ background });
    }
    /**
     * Gets the button badge.
     */
    getBadge() {
        return this.state.badge;
    }
    /**
     * Sets the button badge.
     *
     * @param badge - The button badge.
     */
    setBadge(badge) {
        this.setState({ badge });
    }
    /**
     * Gets the button color.
     */
    getColor() {
        return this.state.color;
    }
    /**
     * Sets the button color.
     *
     * @param color - The button color.
     */
    setColor(color) {
        this.setState({ color });
    }
    /**
     * Returns if the button is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the button is enabled.
     *
     * @param enable - If the button is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Returns if the button is fitParent.
     */
    isFitParent() {
        return this.state.fitParent;
    }
    /**
     * Sets if the button is fitParent.
     *
     * @param fitParent - If the button is fitParent.
     */
    setFitParent(fitParent) {
        this.setState({ fitParent });
    }
    /**
     * Returns if the button is loading.
     */
    isLoading() {
        return Boolean(this.state.loading);
    }
    /**
     * Sets if the button is loading.
     *
     * @param loading - If the the button is loading.
     */
    setLoading(loading) {
        this.setState({ loading });
    }
    /**
     * Returns if the button is preventDefault.
     */
    isPreventDefault() {
        return this.state.preventDefault ?? false;
    }
    /**
     * Sets if the button is preventDefault.
     *
     * @param preventDefault - If the button is preventDefault.
     */
    setPreventDefault(preventDefault) {
        this.setState({ preventDefault });
    }
    /**
     * Returns if the button is stopPropagation.
     */
    isStopPropagation() {
        return this.state.stopPropagation ?? false;
    }
    /**
     * Sets if the button is stopPropagation.
     *
     * @param stopPropagation - If the button is stopPropagation.
     */
    setStopPropagation(stopPropagation) {
        this.setState({ stopPropagation });
    }
    /**
     * Returns if the button is visible.
     */
    isVisible() {
        return this.state.visible;
    }
    /**
     * Sets if the button is visible.
     *
     * @param visible - If the button is visible.
     */
    setVisible(visible) {
        this.setState({ visible });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ButtonAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ButtonAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ButtonAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ButtonAPI.prototype, "onFocus", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ButtonAPI.prototype, "onBlur", void 0);
export { ButtonAPI, };
//# sourceMappingURL=button-api.js.map